import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const trending = articles.slice(0, 5);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-950">
              最新资讯
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">
              影视行业动态与深度内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {trending.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group cursor-pointer ${
                index === 0 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500/80 text-background-950 text-xs font-medium rounded">
                    {article.category}
                  </span>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1.5">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span>{article.date}</span>
                <span>{article.views.toLocaleString()} 阅读</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}